function waitForElement(selector, callback, maxWait = 10000) {
  const startTime = Date.now();

  function checkElement() {
    const element = document.querySelector(selector);

    if (element) {
      callback(element);
      return;
    }

    if (Date.now() - startTime < maxWait) {
      setTimeout(checkElement, 100);
    }
  }

  checkElement();
}

function updateBanner(banner) {
  banner.innerHTML =
    'Utilizamos cookies para uma melhor experiência. <br /> Conheça nossa <a target="__blank" href="https://americachip.com/termos-e-condicoes-de-uso/">Política de Privacidade</a>';
}

document.addEventListener("DOMContentLoaded", function () {
  waitForElement(".adopt-c-ennBjQ", updateBanner);
});

if (document.readyState === "loading") {
} else {
  waitForElement(".adopt-c-ennBjQ", updateBanner);
}
